import { EntitlementData, useEntitlements } from "../../models/entitlements";

export type Tier = "free" | "supporter" | "pro";

export function tierFromEntitlements(e: EntitlementData | undefined): Tier {
  if (e?.pro?.active) return "pro";
  if (e?.supporter?.active) return "supporter";
  return "free";
}

export function useOwnerTier(ownerUid: string | undefined) {
  const [entitlements, loading, error] = useEntitlements(ownerUid);
  const tier = tierFromEntitlements(entitlements);
  return [tier, loading, error] as const;
}
